import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// The old per-role sign-up pages (/fan-signup, /artist-signup - still in
// shared invite links and bookmarks): the one sign-up, with the role picked
// for them and any ?ref= invite kept. Tiny and eagerly bundled, unlike
// Signup itself.
export default function SignupAs({ as }) {
  const params = new URLSearchParams(useLocation().search);
  params.set("as", as);
  return <Navigate to={`/signup?${params}`} replace />;
}
